<!-- associated users links -->
<section>
  <form *ngIf="!isLoading; else spinner" [formGroup]="form" class="wrap">
    <div class="dialog-actions">
      <!-- add @@@ faire composant -->
      <button mat-flat-button class="m-2" color="primary" [appTooltip]="'propertyServiceAssociation.add' | translate"
        (click)="addServiceField()">
        {{ 'propertyServiceAssociation.add' | translate }}
      </button>
    </div>

    <div class="form-group row" *ngIf="isAddingService">
      <app-select [label]="'propertyServiceAssociation.filterByType'" [formControl]="form_filterServices" [size]="12"
        [list]="serviceList" [isEnum]="true" enumName="ServiceType"></app-select>
    </div>

    <div class="form-group row">
      <h1>{{'propertyServiceAssociation.title'|translate}}</h1>
      <ng-container *ngIf="form_services.value.length > 0; else noResult">
        <ul>
          <li *ngFor="let control of form_services.controls">
            <div class="form-group row">
              <app-input [label]="control.value?.uid ? null : 'companyService'" [formControl]="control"
                [autocompletionType]="'propertyService'" [autocompletionQP]="{services: form_filterServices.value}"
                [autocompletionSearchEvenIfEmpty]="true" [autocompletionExcludeIdList]="autocompletionExcludeIds"
                [size]="12" [hasDeleteBtn]="control.value?.uid" [isDisabled]="control.value?.uid"
                (clickedOption)="onAddService($event)" (clickedDelete)="onDeleteService(control.value)"></app-input>
            </div>
          </li>
        </ul>
      </ng-container>
    </div>
  </form>

  <ng-template #noResult>
    <p>{{'noResult'|translate}}</p>
  </ng-template>

</section>

<ng-template #spinner>
  <p class="wrap-spinner">
    <mat-spinner [diameter]="20"></mat-spinner>
  </p>
</ng-template>